import React, { useState } from "react";
import { Col, Nav, Row, Tab } from "react-bootstrap";
import AiImagegenration from "./AiImagegenration";
import Aiimagevariations from "./Aiimagevariations";
import EditImageai from "./EditImageai";

function AiImageMainPage(props) {
  const [activeKey, setactiveKey] = useState("first");
  return (
    <div>
      <Tab.Container
        id="left-tabs-example"
        defaultActiveKey="first"
        activeKey={activeKey}
        onSelect={(k) => {
          setactiveKey(k);
        }}
        mountOnEnter={true}
        unmountOnExit={true}
        forceRenderTabPanel={true}
      >
        <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center">
          <Col xs="12" sm="12">
            <Nav className="justify-content-center align-items-center trans-tabs">
              <Nav.Item>
                <Nav.Link eventKey="first">Ai Image Generate</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="second">Ai Image Variation</Nav.Link>
              </Nav.Item>
              {/* <Nav.Item>
                <Nav.Link eventKey="third">Ai Image Edit</Nav.Link>
              </Nav.Item> */}
            </Nav>
          </Col>
        </Row>
        <div className="trans-tab-content">
          <Tab.Content>
            <Tab.Pane eventKey="first">
              <AiImagegenration />
            </Tab.Pane>
            <Tab.Pane eventKey="second">
              <Aiimagevariations />
            </Tab.Pane>
            <Tab.Pane eventKey="third">
              <EditImageai />
            </Tab.Pane>
          </Tab.Content>
        </div>
      </Tab.Container>
    </div>
  );
}

export default AiImageMainPage;
